export default __webpack_public_path__ + "static/media/AjayUncleJi.ef45ac20.jpeg";